import { httpGet, httpPut } from '../../../../Util/http';
import { addAlert } from '../../../../MsgNotify/msgNotifyActions';


export const UPDATE_DELIVERY_NOTE = 'UPDATE_DELIVERY_NOTE'
export const updateDeliveryNote = (typeOf, index, value) => (
  {
    type: UPDATE_DELIVERY_NOTE,
    typeOf,
    index,
    value
  }
)


export const UPDATE_DELIVERY_NOTE_TOUCHED = 'UPDATE_DELIVERY_NOTE_TOUCHED'
export const updateDeliveryNoteTouched = (typeOf, index) => (
  {
    type: UPDATE_DELIVERY_NOTE_TOUCHED,
    typeOf,
    index
  }
)


export const ADD_DELIVERY_NOTE = 'ADD_DELIVERY_NOTE'
export const addDeliveryNote = () => (
  {
    type: ADD_DELIVERY_NOTE,
    deliveryNote: { number: "", supplier: "", specification: null }
  }
)


export const GET_SUPPLIER_SUGGESTIONS_SUCCESS = 'GET_SUPPLIER_SUGGESTIONS_SUCCESS';
export const getSupplierSuggestionsSuccess = (suggestions) => (
  {
    type: GET_SUPPLIER_SUGGESTIONS_SUCCESS,
    suggestions: suggestions
  }
)


export const getSupplierSuggestions = (val) => {
  var fetchUrl = process.env.REACT_APP_webApiEndPoint + "api/dailyReports/supplier?query=" + val
  return (dispatch) => {
    if (!val) {
      dispatch(getSupplierSuggestionsSuccess([]))
      return;
    }
    return httpGet(fetchUrl)
      .then(response => {
        return response.json();
      })
      .then((json) => {
        dispatch(getSupplierSuggestionsSuccess(json))
      })
      .catch((e) => {
        console.log(e);
      })
  };
}




export const isDeliveryNotesValid = (dispatch, getState) => {

  let deliveryNotes = getState().dailyReportDeliveryNotesReducer.deliveryNotes;

  let isActivitiesValid = true;
  deliveryNotes.forEach((d, index) => {
    //if the activity is invalid act upon it
    if ((!d.supplier && d.number) || (d.supplier && !d.number)) {
      dispatch(updateDeliveryNoteTouched('supplierTouched', index))
      dispatch(updateDeliveryNoteTouched('numberTouched', index))
      isActivitiesValid = false;
    }
  })
  return isActivitiesValid
}


export function attemptSaveDeliveryNotes(currentDailyReportId, getState, dispatch) {
  var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/deliverynotes/register'
  let deliveryNotes = getState().dailyReportDeliveryNotesReducer.deliveryNotes;
  let deliveryNotesToSave = filterSaveAbleDeliveryNotes(deliveryNotes);
  return httpPut(_url, { id: currentDailyReportId, deliveryNotes: deliveryNotesToSave })
    .catch(() => {
      dispatch(addAlert("Kunne ikke gemme følgesedlerne"))
      throw new Error("Kunne ikke gemme følgesedlerne")
    })
}


function filterSaveAbleDeliveryNotes(deliveryNotes) {
  let result = [];
  deliveryNotes.forEach((d) => {
    if (d.number) {
      result.push(d);
    }
  })
  return result;
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/DeliveryNotes/actions.js